import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react';

import { ProgramManagementListItem } from './programs.types';
import { PROGRAM_COMPLETION_ACTION_LABELS, PROGRAM_VISIBILITY_LABELS } from './programs.utils';

interface Props {
    deletingProgramName?: string;
    items: ProgramManagementListItem[];
    onDelete: (name: string) => void;
    onEdit: (name: string) => void;
    onOpen: (name: string) => void;
    onProcess: (name: string) => void;
    processingProgram: boolean;
    processingProgramName?: string;
}

const ProgramListTable: React.FC<Props> = ({ deletingProgramName, items, onDelete, onEdit, onOpen, onProcess, processingProgram, processingProgramName }) => (
    <TableContainer component={Paper} sx={{ borderRadius: 3 }} variant="outlined">
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Program Name</TableCell>
                    <TableCell>Sort</TableCell>
                    <TableCell>Weeks</TableCell>
                    <TableCell>Configured Days</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Completion</TableCell>
                    <TableCell>Next Program</TableCell>
                    <TableCell align="right">Actions</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {items.map((item) => {
                    const isProcessingThisProgram = processingProgram && processingProgramName === item.name;

                    return (
                    <TableRow hover key={item.name}>
                        <TableCell>
                            <Box sx={{ alignItems: 'center', display: 'flex', gap: 1.25 }}>
                                {item.imageUrl ? (
                                    <Box
                                        alt={`${item.displayName} thumbnail`}
                                        component="img"
                                        src={item.imageUrl}
                                        sx={{ borderRadius: 1.5, flexShrink: 0, height: 44, objectFit: 'cover', width: 44 }}
                                    />
                                ) : (
                                    <Box sx={{ alignItems: 'center', backgroundColor: 'grey.100', borderRadius: 1.5, display: 'flex', flexShrink: 0, height: 44, justifyContent: 'center', width: 44 }}>
                                        <Typography color="text.secondary" variant="caption">N/A</Typography>
                                    </Box>
                                )}
                                <Box>
                                    <strong>{item.displayName}</strong>
                                    <div>{item.name}</div>
                                    <Typography color="text.secondary" sx={{ maxWidth: 280 }} variant="caption">{item.description}</Typography>
                                </Box>
                            </Box>
                        </TableCell>
                        <TableCell>{item.sortOrder}</TableCell>
                        <TableCell>{item.totalWeeks}</TableCell>
                        <TableCell>{item.totalDays} / {item.totalWeeks * 7}</TableCell>
                        <TableCell>{item.status} {`• ${PROGRAM_VISIBILITY_LABELS[item.visibility]}`}</TableCell>
                        <TableCell>{PROGRAM_COMPLETION_ACTION_LABELS[item.completionAction]}</TableCell>
                        <TableCell>{item.nextProgramKey || 'None'}</TableCell>
                        <TableCell align="right">
                            <Button onClick={() => onOpen(item.name)} size="small">Open</Button>
                            <Button onClick={() => onEdit(item.name)} size="small">Edit</Button>
                            <Button disabled={processingProgram} onClick={() => onProcess(item.name)} size="small">
                                {isProcessingThisProgram ? 'Processing...' : 'Process'}
                            </Button>
                            <Button color="error" disabled={deletingProgramName === item.name} onClick={() => onDelete(item.name)} size="small">Delete</Button>
                        </TableCell>
                    </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    </TableContainer>
);

export default ProgramListTable;